import service from '@/utils/server';

const modName='/taskPkg/approve/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

/**
 * 新增*提交
 * @param data
 * @returns {*}
 */
export const submitImport = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

/**
 * 编辑初始化
 * @param data
 * @returns {*}
 */
export const taskPkgEditInit = data => {
  return service({
    url: modName + 'taskPkgEditInit',
    method: 'post',
    data
  });
};



/**
 * 修改提交
 * @param data
 */
export const taskPkgEdit =data=>{
  return service({
    url: modName + 'taskPkgEdit',
    method: 'post',
    data
  });
}

/**
 * 详情
 * @param data
 */
export const taskPkgStoreDetail = data =>{
  return service({
    url: modName + 'taskPkgStoreDetail',
    method: 'post',
    data
  });
}

/**
 * 同意
 * @param data
 * @returns {*}
 */
export const approveAgreeSubmit = data =>{
  return service({
    url: modName + 'approveAgreeSubmit',
    method: 'post',
    data
  });
}

/**
 * 拒绝
 * @param data
 * @returns {*}
 */
export const approveRefuseSubmit = data =>{
  return service({
    url: modName + 'approveRefuseSubmit',
    method: 'post',
    data
  });
}

//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};

/**
 * 个人积分导出
 * @param data
 * @returns {*}
 */
export const exportPersonnelPoints = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportPersonnelPoints',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/taskManagement/taskApproval/api/index.js